
export enum ObjectTypeEnum {
  Parcel = 1, 
  Box = 2, 
  }
  